var  freeSamples = {

  	init: function() {
	    if(Cookies.get('free-sample')) {
	    	$('.sample-select').prop('disabled', true);
	    }

	    $( document ).ajaxComplete(function() {
  			if(Cookies.get('free-sample')) {
	    		$('.sample-select').prop('disabled', true);
	    	}

	    	$('.remove.free-samples').on('click', function() {
	    		Cookies.remove('free-sample');
	    	});

	    	if($('.cart--item[data-collection="free-samples"]').length == $('.cart--item').length && $('.cart--item').length != '0' ) { 
	    		Cookies.remove('free-sample');
	    		window.location.href = '/cart/clear';
	    	}
		});

	    $('.cart--root').on('change', '.sample-select', function() {
	    	var productID = $(this).val();
	    	addItemToCart( productID, 1);
	    });

	    $('.remove.free-samples').on('click', function() {
	    	Cookies.remove('free-sample');
	    });

	    function addItemToCart(variant_id, qty) {
		    data = {
		      "id": variant_id,
		      "quantity": 1
		    }
		    
		    jQuery.ajax({
		      type: 'POST',
		      url: '/cart/add.js',
		      data: data,
		      dataType: 'json',
		      success: function() {
		      	Cookies.set('free-sample', '1'); 
                window.location.href = '/cart'; 
		      }
		    });
  		}




	},
}


jQuery(document).ready(function() {
  freeSamples.init();
});
